export const contentWidth = {
  width: "100%",
  maxWidth: 1248,
  mx: "auto",
  px: { xs: 3, sm: 5, lg: 6 },
};

export const sectionHeading = {
  fontSize: { xs: "2rem", md: "2.75rem" },
  letterSpacing: "-0.045em",
  lineHeight: 1.15,
};

export const eyebrow = {
  fontSize: "0.6875rem",
  fontWeight: 700,
  letterSpacing: "0.16em",
  lineHeight: 1.6,
};

export const plannerButton = {
  minHeight: 48,
  px: 3,
  flexShrink: 0,
};
